import React from 'react'
import { Link } from 'react-router-dom'
export const Palermo = () => {
    return (
        <main className='margen1  bg-[#EEF2FF] dark:bg-[#050817]'>
            <section className='mb-3'>
                <h1 className='titulo1 text-center mb-[3rem] '>Agencia de Diseño Web en Palermo</h1>
                <p className=' !font-medium !leading-5'>
                    En Power Bit combinamos creatividad, estrategia y tecnología para crear sitios web que conectan con tu audiencia. Desde Palermo, trabajamos con marcas que buscan destacar en el mundo digital.
                </p>
            </section>

            <section className='mb-3'>
                <h2 className='lg:text-3xl text-xl font-bold mb-3'>¿Qué hacemos?</h2>
                <ul className='!font-medium !leading-5'>
                    <li><strong>Diseño de sitios web</strong> modernos, funcionales y adaptados a cada negocio.</li>
                    <li><strong>Publicidad digital</strong> en redes sociales, campañas segmentadas y contenido visual.</li>
                    <li><strong>Marketing estratégico</strong> para posicionar tu marca y atraer clientes reales.</li>
                </ul>
            </section>

            <section className='mb-3'>
                <h2 className='lg:text-3xl text-xl font-bold mb-3'>Diseño Web desde Palermo, Buenos Aires</h2>
                <p className='!font-medium !leading-5'>
                    Somos un equipo con base en Palermo, apasionado por el diseño y la comunicación digital. Conocemos el ritmo de los negocios locales y regionales, y ofrecemos soluciones que se adaptan a cada cliente. Si buscás una agencia cercana, profesional y con resultados, estás en el lugar correcto.
                </p>
            </section>

            <section className='mb-3'>
                <h2 className='lg:text-3xl text-xl font-bold mb-3'>¿Querés potenciar tu presencia online?</h2>
                <p className='!font-medium !leading-5 mb-5'>
                    Contactanos y contanos tu idea. En Power Bit convertimos proyectos en experiencias digitales que funcionan.
                </p>
                <a href="/#contacto" className="underline font-semibold underline underline-offset-4 dark:font-medium decoration-[#274dd8]  dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600">Solicitá tu propuesta</a>
            </section>
        </main>
    )
}